/* KST skin quiz: DOM engine. Needs window.KstQuizRules and window.KstQuizIntegrations. */
(function () {
  'use strict';

  var R = window.KstQuizRules;
  var I = window.KstQuizIntegrations;
  var STATE_KEY = 'kq_state';
  var AB_KEY = 'kq_ab';
  var CHROMELESS = ['hook', 'loader', 'results'];
  var SEGMENTS = 3;
  var CHECK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  var CHART = '<svg class="kst-quiz__chart" viewBox="0 0 342 200" role="img" aria-label="Expected progress with your routine compared to average"><defs><linearGradient id="kq-g" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#FF4D5E"/><stop offset="1" stop-color="#E8263A"/></linearGradient><filter id="kq-b" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="6"/></filter></defs><path d="M24 150C100 148 170 140 318 120" fill="none" stroke="rgba(41,40,36,.25)" stroke-width="3" stroke-linecap="round"/><path d="M24 150C90 140 150 90 318 36" fill="none" stroke="url(#kq-g)" stroke-width="4" stroke-linecap="round"/><circle cx="318" cy="36" r="14" fill="#FF4D5E" opacity=".6" filter="url(#kq-b)"/><circle cx="318" cy="36" r="6" fill="#E8263A" stroke="#fff" stroke-width="2.5"/><text x="24" y="40" font-family="Inter,sans-serif" font-size="12" font-weight="600" fill="#E8263A">With your routine</text><text x="170" y="150" font-family="Inter,sans-serif" font-size="12" fill="rgba(41,40,36,.75)">On average</text><text x="24" y="182" font-family="Inter,sans-serif" font-size="12" fill="rgba(41,40,36,.75)">Today</text><text x="270" y="182" font-family="Inter,sans-serif" font-size="12" fill="rgba(41,40,36,.75)">Week 12</text></svg>';
  var AGE_LABELS = { u50: 'Under 50', '50s': 'In her 50s', '60s': 'In her 60s', '70p': '70 or older' };

  function isObj(v) { return v !== null && typeof v === 'object' && !Array.isArray(v); }
  /* Navigation goes through one function; the local harness sets window.kstQuizNavigate to log instead of leaving. */
  function navigate(url, replace) {
    if (typeof window.kstQuizNavigate === 'function') window.kstQuizNavigate(url);
    else if (replace) window.location.replace(url);
    else window.location.assign(url);
  }
  function storage(kind) { try { return window[kind]; } catch (e) { return null; } }
  function readJSON(store, key) { try { var v = store && store.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function writeJSON(store, key, val) { try { if (store) store.setItem(key, JSON.stringify(val)); } catch (e) { /* private mode */ } }
  function captureMode(fromUrl, saved) {
    if (fromUrl === 'off' || fromUrl === 'on') return fromUrl;
    return saved === 'off' ? 'off' : 'on';
  }
  function param(name) { try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; } }
  function hashId() { var m = /(?:^|&)s=([^&]+)/.exec(window.location.hash.slice(1)); if (!m) return null; try { return decodeURIComponent(m[1]); } catch (e) { return null; } }
  function money(cents) { return '$' + (Number(cents || 0) / 100).toFixed(2); }
  function safeImageUrl(url, width) {
    if (typeof url !== 'string') return null;
    url = url.trim();
    if (!url) return null;
    if (url.indexOf('https://') !== 0 && url.indexOf('//') !== 0 && url.charAt(0) !== '/') {
      console.warn('kst-quiz: ignoring image URL ' + url);
      return null;
    }
    var host = '';
    var path = url;
    try { var u = new URL(url, window.location.href); host = u.hostname; path = u.pathname; } catch (e) { /* keep raw */ }
    if ((host === 'cdn.shopify.com' || path.indexOf('/cdn/shop/') !== -1) && !/[?&]width=/.test(url)) {
      var hash = '';
      var h = url.indexOf('#');
      if (h !== -1) { hash = url.slice(h); url = url.slice(0, h); }
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width + hash;
    }
    return url;
  }
  // Responsive image sets. SIZES must match the CSS: the quiz column is
  // 30rem wide with 1.5rem padding, and grid tiles are half of that.
  var SCREEN_WIDTHS = [480, 720, 960];
  var SCREEN_SIZES = '(min-width: 480px) 432px, calc(100vw - 48px)';
  var TILE_WIDTHS = [240, 400, 600];
  var TILE_SIZES = '(min-width: 480px) 210px, calc(50vw - 30px)';
  function isShopifyCdn(url) {
    try {
      var u = new URL(url, window.location.href);
      return u.hostname === 'cdn.shopify.com' || u.pathname.indexOf('/cdn/shop/') !== -1;
    } catch (e) { return false; }
  }
  function withWidth(url, w) {
    var hash = '';
    var h = url.indexOf('#');
    if (h !== -1) { hash = url.slice(h); url = url.slice(0, h); }
    if (/[?&]width=\d+/.test(url)) url = url.replace(/([?&])width=\d+/, '$1width=' + w);
    else url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    return url + hash;
  }
  // Sets srcset and sizes before src so the browser fetches one candidate.
  function setSources(img, url, widths, sizes) {
    if (!isShopifyCdn(url)) { img.src = url; return; }
    img.sizes = sizes;
    img.srcset = widths.map(function (w) { return withWidth(url, w) + ' ' + w + 'w'; }).join(', ');
    img.src = withWidth(url, widths[1]);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = text;
    return n;
  }

  function Quiz(root, config) {
    this.root = root;
    this.cfg = config;
    this.settings = isObj(config.settings) ? config.settings : {};
    this.products = isObj(config.products) ? config.products : {};
    this.screens = Array.isArray(config.screens) ? config.screens.filter(function (s) { return isObj(s) && s.type; }) : [];
    this.hasTestimonials = Array.isArray(config.testimonials) && config.testimonials.some(function (t) { return isObj(t) && typeof t.quote === 'string' && t.quote.trim(); });
    this.body = root.querySelector('[data-kq-body]');
    this.top = root.querySelector('[data-kq-top]');
    this.bar = root.querySelector('[data-kq-bar]');
    this.backBtn = root.querySelector('[data-kq-back]');
    this.timers = [];
    this.pushed = false;

    var saved = readJSON(storage('sessionStorage'), STATE_KEY) || {};
    this.state = {
      id: typeof saved.id === 'string' ? saved.id : null,
      answers: isObj(saved.answers) ? saved.answers : {},
      lead: isObj(saved.lead) ? saved.lead : null,
      addedIds: Array.isArray(saved.addedIds) ? saved.addedIds : [],
      utm: param('utm_content') || (typeof saved.utm === 'string' ? saved.utm : ''),
      // Lead capture version: ?capture=off skips the email/SMS screen.
      capture: captureMode(param('capture'), saved.capture)
    };
    var override = param('kq_ab') || (this.settings.ab_enabled === false ? 'off' : null);
    this.ab = R.assignVariant(readJSON(storage('localStorage'), AB_KEY), override, Math.random);
    if (!override) writeJSON(storage('localStorage'), AB_KEY, this.ab);
  }

  Quiz.prototype.visible = function () {
    var a = this.state.answers;
    var hasT = this.hasTestimonials;
    var capture = this.state.capture;
    return this.screens.filter(function (s) {
      if (s.type === 'proof' && !hasT) return false;
      if (s.type === 'email' && capture === 'off') return false;
      return R.showIf(s.show_if, a);
    });
  };

  Quiz.prototype.indexOf = function (id) {
    var list = this.visible();
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return i;
    return -1;
  };

  Quiz.prototype.save = function () {
    writeJSON(storage('sessionStorage'), STATE_KEY, this.state);
  };

  Quiz.prototype.ctx = function (extra) {
    return Object.assign({ ab: this.ab, capture: this.state.capture, utm_content: this.state.utm }, extra || {});
  };

  Quiz.prototype.start = function () {
    var self = this;
    if (!this.screens.length) { this.fail(new Error('kst-quiz: no screens configured')); return; }
    if (this.backBtn) this.backBtn.addEventListener('click', function () { window.history.back(); });
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      var id = hashId() || self.state.id;
      if (!id || self.indexOf(id) === -1) return;
      self.restoring = true;
      try { self.render(id, true); } finally { self.restoring = false; }
    });
    window.addEventListener('popstate', function () {
      var id = hashId();
      if (id && self.indexOf(id) !== -1) self.render(id, true);
    });
    var start = hashId();
    if (!start || this.indexOf(start) === -1) start = this.state.id;
    if (!start || this.indexOf(start) === -1) start = this.visible()[0].id;
    this.render(start, false);
  };

  Quiz.prototype.fail = function (err) {
    console.error(err);
    this.body.textContent = '';
    this.body.appendChild(el('p', 'kst-quiz__text', 'The quiz could not load. Please refresh the page.'));
  };

  Quiz.prototype.next = function (opts) {
    var list = this.visible();
    var i = this.indexOf(this.state.id);
    if (i !== -1 && i + 1 < list.length) this.render(list[i + 1].id, false, !!(opts && opts.replace));
  };

  Quiz.prototype.clearTimers = function () {
    this.timers.forEach(function (t) { clearTimeout(t); });
    this.timers = [];
  };

  Quiz.prototype.later = function (fn, ms) {
    this.timers.push(setTimeout(fn, ms));
  };

  Quiz.prototype.render = function (id, fromHistory, replace) {
    this.clearTimers();
    var list = this.visible();
    var i = this.indexOf(id);
    if (i === -1) i = 0;
    var s = list[i];
    this.state.id = s.id;
    this.save();

    var url = window.location.pathname + window.location.search + '#s=' + encodeURIComponent(s.id);
    if (!fromHistory) {
      if (this.pushed && !replace) window.history.pushState({ kq: s.id }, '', url);
      else window.history.replaceState({ kq: s.id }, '', url);
      this.pushed = true;
    }

    var chromeless = CHROMELESS.indexOf(s.type) !== -1;
    this.top.hidden = chromeless;
    if (!chromeless) {
      this.backBtn.setAttribute('aria-hidden', i === 0 ? 'true' : 'false');
      this.backBtn.tabIndex = i === 0 ? -1 : 0;
      this.drawBar(R.progressPct(list, i));
    }

    this.body.textContent = '';
    this.body.className = 'kst-quiz__body';
    var builder = this['screen_' + s.type];
    if (typeof builder !== 'function') {
      console.warn('kst-quiz: unknown screen type "' + s.type + '" on ' + s.id);
      this.next({ replace: true });
      return;
    }
    try { builder.call(this, s, i, list); this.placeScreenImage(s); } catch (e) { this.fail(e); return; }
    this.warmNext(s.id);
    if (!this.restoring) I.track('screen_view', this.ctx({ screen_id: s.id, index: i }));
    window.scrollTo(0, 0);
    var h = this.body.querySelector('.kst-quiz__title');
    if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); }
  };

  Quiz.prototype.drawBar = function (pct) {
    this.bar.textContent = '';
    R.segmentFills(pct, SEGMENTS).forEach(function (fill) {
      var seg = el('span', 'kst-quiz__seg');
      var f = el('span', 'kst-quiz__seg-fill');
      f.style.width = fill + '%';
      seg.appendChild(f);
      this.bar.appendChild(seg);
    }, this);
    this.bar.setAttribute('role', 'progressbar');
    this.bar.setAttribute('aria-valuemin', '0');
    this.bar.setAttribute('aria-valuemax', '100');
    this.bar.setAttribute('aria-valuenow', String(pct));
  };

  Quiz.prototype.title = function (text, hero, tag) {
    var t = el(tag || 'h2', 'kst-quiz__title' + (hero ? ' kst-quiz__title--hero' : ''), text || '');
    this.body.appendChild(t);
    return t;
  };

  Quiz.prototype.text = function (cls, text) {
    if (!text) return null;
    var p = el('p', cls, text);
    this.body.appendChild(p);
    return p;
  };

  Quiz.prototype.image = function (src, glowTop) {
    if (glowTop != null) {
      var g = el('span', 'kst-quiz__glow');
      g.style.top = glowTop + 'px';
      g.setAttribute('aria-hidden', 'true');
      this.body.appendChild(g);
    }
    if (!src) return;
    var img = el('img', 'kst-quiz__img');
    img.alt = '';
    img.loading = 'eager';
    img.fetchPriority = 'high';
    setSources(img, src, SCREEN_WIDTHS, SCREEN_SIZES);
    this.body.appendChild(img);
  };

  // Fetches the next two screens' photos in the background, so they are
  // already cached when the shopper taps Continue.
  Quiz.prototype.warmNext = function (id) {
    var self = this;
    var run = function () {
      var list = self.visible();
      var i = self.indexOf(id);
      if (i === -1) return;
      self.warmed = self.warmed || {};
      list.slice(i + 1, i + 3).forEach(function (s) {
        var jobs = [];
        if (s.type !== 'hook') jobs.push([safeImageUrl(s.image, 1000), SCREEN_WIDTHS, SCREEN_SIZES]);
        if (s.layout === 'grid') R.parseOptions(s.options).forEach(function (o) { jobs.push([safeImageUrl(o.image, 600), TILE_WIDTHS, TILE_SIZES]); });
        jobs.forEach(function (j) {
          if (!j[0] || self.warmed[j[0]]) return;
          self.warmed[j[0]] = true;
          var img = new Image();
          img.decoding = 'async';
          setSources(img, j[0], j[1], j[2]);
        });
      });
    };
    if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 1500 });
    else setTimeout(run, 300);
  };

  Quiz.prototype.placeScreenImage = function (s) {
    if (s.type === 'hook') return;
    var src = safeImageUrl(s.image, 1000);
    if (!src) return;
    var img = el('img', 'kst-quiz__screen-img' + (s.image_shape === 'banner' ? ' kst-quiz__screen-img--short' : ''));
    img.alt = '';
    img.decoding = 'async';
    setSources(img, src, SCREEN_WIDTHS, SCREEN_SIZES);
    var title = this.body.querySelector('.kst-quiz__title');
    if (!title) { this.body.insertBefore(img, this.body.firstChild); return; }
    if (s.image_position === 'below') {
      var after = title;
      var nx = after.nextElementSibling;
      while (nx && (nx.classList.contains('kst-quiz__text') || nx.classList.contains('kst-quiz__help') || nx.classList.contains('kst-quiz__bullets'))) {
        after = nx;
        nx = after.nextElementSibling;
      }
      this.body.insertBefore(img, after.nextSibling);
    } else {
      var before = title;
      var prev = title.previousElementSibling;
      if (prev && prev.classList.contains('kst-quiz__eyebrow')) before = prev;
      this.body.insertBefore(img, before);
    }
  };

  Quiz.prototype.footer = function (label, onClick) {
    var f = el('div', 'kst-quiz__footer');
    var b = el('button', 'kst-quiz__cta', label || 'Continue');
    b.type = 'button';
    var locked = false;
    b.addEventListener('click', function (ev) {
      if (locked) return;
      locked = true;
      setTimeout(function () { locked = false; }, 400);
      onClick(ev);
    });
    f.appendChild(b);
    this.body.appendChild(f);
    return b;
  };

  Quiz.prototype.setAnswer = function (s, value) {
    if (!s.field) { console.warn('kst-quiz: screen ' + s.id + ' has no answer field'); return; }
    this.state.answers[s.field] = value;
    this.save();
    I.track('answer', this.ctx({ screen_id: s.id, field: s.field, value: Array.isArray(value) ? value.join(',') : value }));
  };

  Quiz.prototype.optionButton = function (label, selected) {
    var b = el('button', 'kst-quiz__option' + (selected ? ' kst-quiz__option--selected' : ''));
    b.type = 'button';
    b.setAttribute('aria-pressed', selected ? 'true' : 'false');
    b.appendChild(el('span', 'kst-quiz__option-label', label));
    var c = el('span', 'kst-quiz__check');
    c.innerHTML = CHECK;
    b.appendChild(c);
    return b;
  };

  Quiz.prototype.tileButton = function (o, selected, wide) {
    var b = el('button', 'kst-quiz__tile' + (wide ? ' kst-quiz__tile--wide' : '') + (selected ? ' kst-quiz__option--selected' : ''));
    b.type = 'button';
    b.setAttribute('aria-pressed', selected ? 'true' : 'false');
    var src = safeImageUrl(o.image, 600);
    if (src) {
      var img = el('img', 'kst-quiz__tile-img');
      img.alt = '';
      img.decoding = 'async';
      setSources(img, src, TILE_WIDTHS, TILE_SIZES);
      b.appendChild(img);
    } else {
      b.appendChild(el('div', 'kst-quiz__tile-img kst-quiz__tile-img--empty'));
    }
    b.appendChild(el('span', 'kst-quiz__tile-label', o.label));
    var c = el('span', 'kst-quiz__check');
    c.innerHTML = CHECK;
    b.appendChild(c);
    return b;
  };

  Quiz.prototype.screen_hook = function (s) {
    this.body.classList.add('kst-quiz__body--hook');
    var preset = R.matchPreset(this.cfg.presets, this.state.utm);
    this.text('kst-quiz__eyebrow', s.eyebrow);
    this.title(preset && preset.headline ? preset.headline : s.heading, true, 'h1');
    this.text('kst-quiz__text', preset && preset.subhead ? preset.subhead : s.body);
    this.image(safeImageUrl(preset && preset.image ? preset.image : s.image, 1000), 80);
    if (s.proof) {
      var p = el('p', 'kst-quiz__proof-line');
      p.appendChild(el('span', 'kst-quiz__stars', '★★★★★'));
      p.appendChild(document.createTextNode(' ' + s.proof));
      this.body.appendChild(p);
    }
    var self = this;
    this.footer(s.button || 'Start', function () {
      I.track('quiz_started', self.ctx({ preset: preset ? preset.utm_content : '' }));
      self.next();
    });
  };

  Quiz.prototype.screen_info = function (s) {
    this.text('kst-quiz__eyebrow', s.eyebrow);
    var heading = R.fillOutcome(s.heading, this.state.answers);
    this.title(heading === null ? "Here's what we'll focus on for you" : heading);
    this.richText(s.body);
    var self = this;
    this.footer(s.button || 'Continue', function () { self.next(); });
  };

  // Body text with "- " bullets and "[field=value]" conditional lines.
  Quiz.prototype.richText = function (text) {
    var self = this, ul = null;
    R.parseRichText(text, this.state.answers).forEach(function (b) {
      if (b.type === 'li') {
        if (!ul) { ul = el('ul', 'kst-quiz__bullets'); self.body.appendChild(ul); }
        var li = el('li');
        if (b.lead) li.appendChild(el('strong', null, b.lead + ': '));
        li.appendChild(document.createTextNode(b.text));
        ul.appendChild(li);
      } else {
        ul = null;
        if (b.type === 'p') self.body.appendChild(el('p', 'kst-quiz__text', b.text));
      }
    });
  };

  Quiz.prototype.screen_single = function (s) {
    var self = this;
    this.title(s.heading);
    this.text('kst-quiz__help', s.help);
    var grid = s.layout === 'grid';
    var wrap = el('div', grid ? 'kst-quiz__grid' : 'kst-quiz__options');
    var current = this.state.answers[s.field];
    var sopts = R.parseOptions(s.options);
    sopts.forEach(function (o, n) {
      var b = grid ? self.tileButton(o, current === o.value, sopts.length % 2 === 1 && n === sopts.length - 1) : self.optionButton(o.label, current === o.value);
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(wrap.children, function (x) {
          x.classList.remove('kst-quiz__option--selected');
          x.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('kst-quiz__option--selected');
        b.setAttribute('aria-pressed', 'true');
        self.setAnswer(s, o.value);
        self.later(function () { self.next(); }, 250);
      });
      wrap.appendChild(b);
    });
    this.body.appendChild(wrap);
  };

  Quiz.prototype.screen_multi = function (s) {
    var self = this;
    var none = s.none_value || null;
    var selected = Array.isArray(this.state.answers[s.field]) ? this.state.answers[s.field].slice() : [];
    this.title(s.heading);
    this.text('kst-quiz__help', s.help);
    var grid = s.layout === 'grid';
    var wrap = el('div', grid ? 'kst-quiz__grid' : 'kst-quiz__options');
    var opts = R.parseOptions(s.options);
    var cta;
    function paint() {
      Array.prototype.forEach.call(wrap.children, function (b, n) {
        var on = selected.indexOf(opts[n].value) !== -1;
        b.classList.toggle('kst-quiz__option--selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      cta.disabled = selected.length === 0;
    }
    opts.forEach(function (o, n) {
      var b = grid ? self.tileButton(o, false, opts.length % 2 === 1 && n === opts.length - 1) : self.optionButton(o.label, false);
      b.addEventListener('click', function () {
        selected = R.toggleMulti(selected, o.value, none);
        paint();
      });
      wrap.appendChild(b);
    });
    this.body.appendChild(wrap);
    cta = this.footer(s.button || 'Next', function () {
      self.setAnswer(s, selected);
      self.next();
    });
    paint();
  };

  Quiz.prototype.screen_scale = function (s) {
    var self = this;
    this.text('kst-quiz__help', s.help || 'Do you relate to this statement?');
    this.title(s.heading);
    var row = el('div', 'kst-quiz__scale');
    for (var n = 1; n <= 5; n++) {
      (function (v) {
        var b = el('button', 'kst-quiz__scale-btn' + (self.state.answers[s.field] === String(v) ? ' kst-quiz__option--selected' : ''), String(v));
        b.type = 'button';
        b.addEventListener('click', function () {
          b.classList.add('kst-quiz__option--selected');
          self.setAnswer(s, String(v));
          self.later(function () { self.next(); }, 250);
        });
        row.appendChild(b);
      })(n);
    }
    this.body.appendChild(row);
    var labels = el('div', 'kst-quiz__scale-labels');
    labels.appendChild(el('span', null, 'Strongly disagree'));
    labels.appendChild(el('span', null, 'Strongly agree'));
    this.body.appendChild(labels);
  };

  Quiz.prototype.screen_date = function (s) {
    var self = this;
    this.title(s.heading);
    this.text('kst-quiz__help', s.help);
    var input = el('input', 'kst-quiz__input');
    input.type = 'date';
    input.id = 'kq-' + s.id;
    input.setAttribute('aria-label', s.heading || 'Date');
    if (typeof this.state.answers[s.field] === 'string') input.value = this.state.answers[s.field];
    this.body.appendChild(input);
    var cta = this.footer(s.button || 'Next', function () {
      self.setAnswer(s, input.value);
      self.next();
    });
    cta.disabled = !input.value;
    input.addEventListener('input', function () { cta.disabled = !input.value; });
    var skip = el('button', 'kst-quiz__skip', s.skip_label || 'Skip');
    skip.type = 'button';
    skip.addEventListener('click', function () {
      if (s.field) { delete self.state.answers[s.field]; self.save(); }
      self.next();
    });
    cta.parentNode.appendChild(skip);
  };

  Quiz.prototype.screen_meter = function (s, i, list) {
    var pct = R.progressPct(list, i);
    var glow = el('span', 'kst-quiz__glow');
    glow.style.top = '0px';
    glow.setAttribute('aria-hidden', 'true');
    this.body.appendChild(glow);
    var m = el('div', 'kst-quiz__meter');
    m.appendChild(el('div', 'kst-quiz__meter-num', pct + '%'));
    this.body.appendChild(m);
    this.title(String(s.heading || '').replace(/\{pct\}/g, String(pct)));
    var holder = el('div');
    holder.innerHTML = CHART;
    this.body.appendChild(holder.firstChild);
    this.text('kst-quiz__text', s.body);
    var self = this;
    this.footer(s.button || 'Continue', function () { self.next(); });
  };

  Quiz.prototype.screen_proof = function (s) {
    if (s.proof) {
      var p = el('p', 'kst-quiz__proof-line');
      p.appendChild(el('span', 'kst-quiz__stars', '★★★★★'));
      p.appendChild(document.createTextNode(' ' + s.proof));
      this.body.appendChild(p);
    }
    this.title(s.heading);
    var t = R.pickTestimonial(this.cfg.testimonials, this.state.answers);
    if (t && t.quote) {
      var card = el('div', 'kst-quiz__card');
      card.appendChild(el('p', 'kst-quiz__quote', t.quote));
      var meta = [t.name, AGE_LABELS[t.age_band]].filter(Boolean).join(', ');
      if (meta) card.appendChild(el('p', 'kst-quiz__meta', meta));
      this.body.appendChild(card);
    }
    var self = this;
    this.footer(s.button || 'Continue', function () { self.next(); });
  };

  Quiz.prototype.optionLabel = function (field, value) {
    if (!value) return '';
    for (var i = 0; i < this.screens.length; i++) {
      if (this.screens[i].field !== field) continue;
      var opts = R.parseOptions(this.screens[i].options);
      for (var j = 0; j < opts.length; j++) if (opts[j].value === value) return opts[j].label;
    }
    return '';
  };

  Quiz.prototype.recommendation = function () {
    try { return R.recommend(this.state.answers, this.products); } catch (e) { console.error(e); return null; }
  };

  Quiz.prototype.screen_profile = function (s) {
    this.text('kst-quiz__eyebrow', s.eyebrow);
    this.title(s.heading);
    var rec = this.recommendation();
    if (rec) this.text('kst-quiz__profile', rec.profile);
    var self = this;
    this.footer(s.button || 'Continue', function () { self.next(); });
  };

  Quiz.prototype.screen_loader = function (s) {
    var self = this;
    this.body.className = 'kst-quiz__body kst-quiz__body--center';
    var glow = el('span', 'kst-quiz__glow');
    glow.style.top = '120px';
    glow.setAttribute('aria-hidden', 'true');
    this.body.appendChild(glow);
    this.title(s.heading);
    var steps = String(s.steps || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean);
    var ul = el('ul', 'kst-quiz__steps');
    var rows = steps.map(function (label) {
      var li = el('li', 'kst-quiz__step');
      var row = el('div', 'kst-quiz__step-row');
      row.appendChild(el('span', null, label));
      li.appendChild(row);
      var track = el('span', 'kst-quiz__step-track');
      var fill = el('span', 'kst-quiz__step-fill');
      track.appendChild(fill);
      li.appendChild(track);
      ul.appendChild(li);
      return { li: li, row: row, fill: fill };
    });
    this.body.appendChild(ul);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = Math.max(1, Math.min(5, Number(s.seconds) || 2)) * (reduce ? 300 : 1000);
    function run(n) {
      if (n >= rows.length) { self.later(function () { self.next({ replace: true }); }, 300); return; }
      var r = rows[n];
      r.li.classList.add('kst-quiz__step--active');
      r.fill.style.transition = reduce ? 'none' : 'width ' + ms + 'ms linear';
      self.later(function () { r.fill.style.width = '100%'; }, 30);
      self.later(function () {
        r.li.classList.remove('kst-quiz__step--active');
        r.li.classList.add('kst-quiz__step--done');
        var ok = el('span', 'kst-quiz__step-ok');
        ok.innerHTML = CHECK;
        r.row.appendChild(ok);
        run(n + 1);
      }, ms + 60);
    }
    run(0);
  };

  Quiz.prototype.screen_email = function (s) {
    var self = this;
    this.title(s.heading);
    this.text('kst-quiz__text', s.body);
    var form = el('form', 'kst-quiz__form');
    form.noValidate = true;
    var lead = this.state.lead || {};

    var emailField = el('div', 'kst-quiz__field');
    var emailLabel = el('label', 'kst-quiz__label', 'Email');
    emailLabel.htmlFor = 'kq-email';
    var email = el('input', 'kst-quiz__input');
    email.type = 'email'; email.id = 'kq-email'; email.name = 'email'; email.autocomplete = 'email'; email.required = true;
    email.value = lead.email || '';
    emailField.appendChild(emailLabel); emailField.appendChild(email);
    form.appendChild(emailField);

    var sms = el('button', 'kst-quiz__toggle');
    sms.type = 'button';
    sms.setAttribute('role', 'switch');
    sms.setAttribute('aria-checked', lead.sms ? 'true' : 'false');
    sms.appendChild(el('span', 'kst-quiz__toggle-text', s.sms_label || 'Text me my routine'));
    sms.appendChild(el('span', 'kst-quiz__switch'));
    if (s.sms_label) form.appendChild(sms);

    var phoneField = el('div', 'kst-quiz__field');
    var phoneLabel = el('label', 'kst-quiz__label', 'Mobile number');
    phoneLabel.htmlFor = 'kq-phone';
    var phone = el('input', 'kst-quiz__input');
    phone.type = 'tel'; phone.id = 'kq-phone'; phone.name = 'phone'; phone.autocomplete = 'tel';
    phone.value = lead.phoneRaw || '';
    phoneField.appendChild(phoneLabel); phoneField.appendChild(phone);
    var smsConsent = el('p', 'kst-quiz__fine', s.sms_consent || '');
    form.appendChild(phoneField);
    form.appendChild(smsConsent);

    function syncSms() {
      var on = sms.getAttribute('aria-checked') === 'true';
      phoneField.hidden = !on;
      smsConsent.hidden = !on || !s.sms_consent;
    }
    sms.addEventListener('click', function () {
      sms.setAttribute('aria-checked', sms.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
      syncSms();
    });
    syncSms();

    if (s.consent) form.appendChild(el('p', 'kst-quiz__fine', s.consent));
    if (this.settings.privacy_url) {
      var pp = el('p', 'kst-quiz__fine');
      var a = el('a', null, 'Privacy policy');
      a.href = this.settings.privacy_url;
      a.target = '_blank';
      a.rel = 'noopener';
      pp.appendChild(a);
      form.appendChild(pp);
    }
    var err = el('p', 'kst-quiz__error');
    err.setAttribute('role', 'alert');
    err.hidden = true;
    form.appendChild(err);

    var footer = el('div', 'kst-quiz__footer');
    var cta = el('button', 'kst-quiz__cta', s.button || 'Continue');
    cta.type = 'submit';
    footer.appendChild(cta);
    form.appendChild(footer);
    this.body.appendChild(form);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      err.hidden = true;
      email.removeAttribute('aria-invalid');
      phone.removeAttribute('aria-invalid');
      var value = email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        email.setAttribute('aria-invalid', 'true');
        err.textContent = 'Please enter a valid email address.';
        err.hidden = false;
        email.focus();
        return;
      }
      var smsOn = sms.getAttribute('aria-checked') === 'true' && !!s.sms_label;
      var e164 = smsOn ? I.normalizePhone(phone.value) : null;
      if (smsOn && !e164) {
        phone.setAttribute('aria-invalid', 'true');
        err.textContent = 'Please enter a 10-digit US mobile number, or turn off texts.';
        err.hidden = false;
        phone.focus();
        return;
      }
      self.state.lead = { email: value, sms: smsOn, phone: e164, phoneRaw: smsOn ? phone.value : '' };
      self.save();
      I.captureLead({
        lead: self.state.lead,
        answers: self.state.answers,
        companyId: self.settings.klaviyo_company_id,
        listId: self.settings.klaviyo_list_id
      });
      I.track('email_submitted', self.ctx({ sms: smsOn }));
      self.next();
    });
  };

  // Face circle positions (percent of the square): main face first.
  var FACES = [['main', 50, 50], ['lg', 20, 24], ['sm', 50, 6], ['lg', 83, 22], ['sm', 94, 52], ['lg', 80, 82], ['sm', 50, 95], ['lg', 18, 78], ['sm', 5, 50]];

  Quiz.prototype.screen_qualify = function (s) {
    var self = this;
    var badge = el('p', 'kst-quiz__badge');
    var icon = el('span', 'kst-quiz__badge-icon');
    icon.innerHTML = CHECK;
    badge.appendChild(icon);
    badge.appendChild(document.createTextNode(s.eyebrow || 'Congratulations, you qualify!'));
    this.body.appendChild(badge);
    this.title(s.heading).classList.add('kst-quiz__center');
    var t = this.text('kst-quiz__text', s.body);
    if (t) t.classList.add('kst-quiz__center');
    var urls = R.parseLines(s.faces).slice(0, FACES.length);
    if (urls.length) {
      var wrap = el('div', 'kst-quiz__faces');
      wrap.setAttribute('aria-hidden', 'true');
      wrap.appendChild(el('span', 'kst-quiz__faces-glow'));
      wrap.appendChild(el('span', 'kst-quiz__faces-ring kst-quiz__faces-ring--outer'));
      wrap.appendChild(el('span', 'kst-quiz__faces-ring kst-quiz__faces-ring--inner'));
      urls.forEach(function (u, i) {
        var src = safeImageUrl(u, i === 0 ? 400 : 160);
        if (!src) return;
        var f = FACES[i];
        var img = el('img', 'kst-quiz__face kst-quiz__face--' + f[0]);
        img.style.left = f[1] + '%';
        img.style.top = f[2] + '%';
        img.alt = '';
        img.decoding = 'async';
        img.src = src;
        wrap.appendChild(img);
      });
      this.body.appendChild(wrap);
    }
    this.footer(s.button || 'Continue', function () { self.next(); });
  };

  // Results: timeline to the goal month, guarantee, and one button to the serum PDP.
  var BAR_HEIGHTS = [22, 34, 48, 64, 78, 90];
  var BAR_COLORS = ['#FFE1E5', '#FFC9D0', '#FFA9B4', '#FF8090', '#F2546A', '#E8263A'];

  Quiz.prototype.screen_results = function (s) {
    var self = this;
    var rec = this.recommendation();
    var serum = this.products.S;
    var t = R.timeline(new Date(), BAR_HEIGHTS.length, Number(s.goal_index) || 3);
    if (!this.restoring) I.track('results_viewed', this.ctx({ goal_month: t.goalMonth, items: 'S' }));

    this.text('kst-quiz__lead', s.eyebrow);
    this.title((s.heading || '').split('{month}').join(t.goalMonth)).classList.add('kst-quiz__center');
    var segs = R.underlineSegments(s.body);
    if (segs.length) {
      var body = el('p', 'kst-quiz__text kst-quiz__center');
      segs.forEach(function (x) { body.appendChild(x.u ? el('u', null, x.text) : document.createTextNode(x.text)); });
      this.body.appendChild(body);
    }
    this.text('kst-quiz__refund', s.refund);

    var chart = el('div', 'kst-quiz__chart');
    chart.setAttribute('role', 'img');
    chart.setAttribute('aria-label', 'Your timeline from ' + t.labels[0] + ' to ' + t.labels[t.labels.length - 1] + ', with your goal in ' + t.goalMonth);
    var bars = el('div', 'kst-quiz__chart-bars');
    BAR_HEIGHTS.forEach(function (h, i) {
      var col = el('div', 'kst-quiz__chart-col');
      var bar = el('div', 'kst-quiz__chart-bar');
      bar.style.height = h + '%';
      bar.style.background = BAR_COLORS[i];
      bar.style.animationDelay = (i * 90) + 'ms';
      col.appendChild(bar);
      if (i === t.goalIndex) {
        var g = el('div', 'kst-quiz__chart-goal');
        g.style.bottom = 'calc(' + h + '% - .9rem)';
        g.appendChild(el('span', 'kst-quiz__chart-pill', s.goal_label || 'Goal'));
        g.appendChild(el('span', 'kst-quiz__chart-dot'));
        col.appendChild(g);
      }
      bars.appendChild(col);
    });
    chart.appendChild(bars);
    var labels = el('div', 'kst-quiz__chart-labels');
    labels.appendChild(el('span', null, t.labels[0]));
    labels.appendChild(el('span', null, t.labels[t.labels.length - 1]));
    chart.appendChild(labels);
    this.body.appendChild(chart);

    if (!serum || !serum.handle) {
      this.text('kst-quiz__error', 'This product is not available right now.');
      return;
    }
    var url = R.pdpUrl(serum.handle, rec ? rec.profileSlug : 'quiz', this.state.utm);
    this.footer(s.button || 'Claim your discount', function () {
      I.track('pdp_clicked', self.ctx({ handle: serum.handle, goal_month: t.goalMonth }));
      navigate(url);
    });
  };

  function boot() {
    if (!R || !I) { console.error('kst-quiz: rules or integrations script missing'); return; }
    Array.prototype.forEach.call(document.querySelectorAll('[data-kst-quiz]'), function (root) {
      var node = root.querySelector('script[data-kq-config]');
      var config = null;
      try { config = JSON.parse(node ? node.textContent : ''); } catch (e) { config = null; }
      if (!isObj(config)) {
        var body = root.querySelector('[data-kq-body]');
        console.error('kst-quiz: config missing or invalid');
        if (body) { body.textContent = ''; body.appendChild(el('p', 'kst-quiz__text', 'The quiz could not load. Please refresh the page.')); }
        return;
      }
      new Quiz(root, config).start();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
